import axiosInstance from './axiosInstance';
import axiosV2Instance from './axiosV2Instance';

export interface QuestionMemberAddPermission {
  id: number;
  siteMemberId: number;
  allowedRoleId: number;
  typeId: number;
  createdAt: string;
  createdBy?: number | null;
  allowedRoleName?: string;
  typeName?: string;
  typeDescription?: string;
  createdByUserName?: string;
}

export interface GrantAddPermissionRequest {
  roleId: number;
  typeId: number;
}

export interface ResetPermissionsRequest {
  roleId: number;
}

class QuestionMemberAddPermissionsApi {
  /**
   * Получить все права на добавление участников для конкретного участника проекта
   */
  async getAddPermissions(siteId: number, siteMemberId: number): Promise<QuestionMemberAddPermission[]> {
    try {
      console.log(`API: Getting permissions for site ${siteId}, member ${siteMemberId}`);
      const response = await axiosV2Instance.get<QuestionMemberAddPermission[]>(
        `/sites/${siteId}/members/${siteMemberId}/add-permissions`
      );
      console.log('API: Permissions response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching add permissions:', error);
      throw error;
    }
  }

  /**
   * Получить права на добавление участников для конкретного типа контента
   */
  async getAddPermissionsByType(
    siteId: number,
    siteMemberId: number,
    typeId: number
  ): Promise<QuestionMemberAddPermission[]> {
    try {
      const response = await axiosV2Instance.get<QuestionMemberAddPermission[]>(
        `/sites/${siteId}/members/${siteMemberId}/add-permissions/type/${typeId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching add permissions by type:', error);
      throw error;
    }
  }

  /**
   * Получить список ID ролей, которые участник может добавлять
   */
  async getAllowedRoleIds(siteId: number, siteMemberId: number, typeId: number): Promise<number[]> {
    try {
      const response = await axiosV2Instance.get<number[]>(
        `/sites/${siteId}/members/${siteMemberId}/add-permissions/type/${typeId}/allowed-roles`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching allowed role IDs:', error);
      throw error;
    }
  }

  /**
   * Добавить право на добавление участников определенной роли
   */
  async grantAddPermission(
    siteId: number,
    siteMemberId: number,
    roleId: number,
    typeId: number
  ): Promise<number> {
    try {
      const response = await axiosV2Instance.post<{ id: number }>(
        `/sites/${siteId}/members/${siteMemberId}/add-permissions`,
        { roleId, typeId }
      );
      return response.data.id;
    } catch (error) {
      console.error('Error granting add permission:', error);
      throw error;
    }
  }

  /**
   * Отозвать право на добавление участников определенной роли
   */
  async revokeAddPermission(
    siteId: number,
    siteMemberId: number,
    roleId: number,
    typeId: number
  ): Promise<void> {
    try {
      await axiosV2Instance.delete(
        `/sites/${siteId}/members/${siteMemberId}/add-permissions/role/${roleId}/type/${typeId}`
      );
    } catch (error) {
      console.error('Error revoking add permission:', error);
      throw error;
    }
  }

  /**
   * Сбросить права на дефолтные (на основе иерархии роли)
   */
  async resetToDefault(siteId: number, siteMemberId: number, roleId: number): Promise<void> {
    try {
      await axiosV2Instance.post(
        `/sites/${siteId}/members/${siteMemberId}/add-permissions/reset`,
        { roleId }
      );
    } catch (error) {
      console.error('Error resetting permissions to default:', error);
      throw error;
    }
  }

  /**
   * Получить ID ролей, которые текущий пользователь может добавлять в контент
   */
  async getAddableRoleIds(siteId: number, typeId: number): Promise<number[]> {
    try {
      const response = await axiosV2Instance.get<number[]>(
        `/sites/${siteId}/members/addable-roles`,
        { params: { typeId } }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching addable role IDs:', error);
      return [];
    }
  }
}

export const questionMemberAddPermissionsApi = new QuestionMemberAddPermissionsApi();

